export default __webpack_public_path__ + "static/media/Heaven's Chang.57db9473.jpg";